import { useEffect, useState } from "react";
import { readEncryptedJsonResponse } from "../common/readEncryptedJsonResponse";
import { createCookie, readCookie, to12HourFormat } from "../common/helper";
import { NavLink } from "react-router-dom";

function JackpotResultChart() {

    const [markets, setMarkets] = useState([]);

    useEffect(() => {
        let _markets = readCookie("Star123-jackpot-chart-markets");

        if (_markets) {
            _markets = JSON.parse(_markets);
            setMarkets(_markets);
        } else {
            fetchData();
        }
    }, []);

    const fetchData = async () => {
        const host = process.env.REACT_APP_API_HOST;

        fetch(host + '/api/jackpot-listing', {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                return readEncryptedJsonResponse(response);
            })
            .then((data) => {
                setMarkets(data);
                createCookie('Star123-jackpot-chart-markets', JSON.stringify(data),1);
            })
            .catch((error) => {
                console.log("Error => ", error)
            });
    }

    return (
        <main className="container chart-wrapper">
            <h1 className="h2 text-center">Jackpot Charts</h1>
            <section className="market-charts-board">
                <div className="market-charts-table">
                    <div className="market-charts-row market-charts-row--head">
                        <div className="market-charts-col market-charts-col--provider">Provider</div>
                        <div className="market-charts-col market-charts-col--action">Chart</div>
                    </div>
                    {
                        markets.length > 1 ?
                            markets.map((m, i) => {
                                return (
                                    <div className="market-charts-row" key={i}>
                                        <div className="market-charts-col market-charts-col--provider">
                                            <h4 className="market-name mb-0">{to12HourFormat(m.time)}</h4>
                                        </div>
                                        <div className="market-charts-col market-charts-col--action">
                                            <NavLink
                                                to={"/chart/jackpot/" + m.time}
                                                className="button__wrapper chart-market-btn"
                                                style={{ transition: "all .3s" }}
                                            >
                                                <span className="chart-market-btn__icon" aria-hidden="true">
                                                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M1.5 12C3.6 7.8 7.3 5.5 12 5.5C16.7 5.5 20.4 7.8 22.5 12C20.4 16.2 16.7 18.5 12 18.5C7.3 18.5 3.6 16.2 1.5 12Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                                        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
                                                    </svg>
                                                </span>
                                                View
                                            </NavLink>
                                        </div>
                                    </div>
                                );
                            })
                            : Array.from({ length: 12 }).map((_, i) => (
                                <div className="market-charts-row" key={i}>
                                    <div className="market-charts-col market-charts-col--provider">
                                        <div className="Polaris-SkeletonDisplayText__DisplayText Polaris-SkeletonDisplayText--sizeMedium"></div>
                                    </div>
                                    <div className="market-charts-col market-charts-col--action">
                                        <div className="Polaris-SkeletonDisplayText__DisplayText Polaris-SkeletonDisplayText--sizeMedium"></div>
                                    </div>
                                </div>
                            ))
                    }
                </div>
            </section>
            
        </main>

    );
}


export default JackpotResultChart;